import { Component, OnInit } from '@angular/core';
import { SimpleModalService } from 'ngx-simple-modal';
import { environment } from 'src/environments/environment';
import { Constants } from '../common/constants';
import { GUI } from '../common/gui';
import { HttpUtils } from '../common/http-utils';
import { LoaderService } from '../common/loader-service';
import { LocalStorage } from '../common/local-storage';
import { Toast } from '../common/toast';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { SearchModalComponent } from '../search-modal/search-modal.component';
import * as CryptoJS from 'crypto-js';
import { SelectPaymentModalComponent } from '../select-payment-modal/select-payment-modal.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  private dashboardForm: HTMLFormElement;

  incompleteApplicationsList: any[];

  completedApplicationsList: any[];

  paidApplicationsList: any[];

  currentTab: string = this.constants.BLANK;

  selectedAllApplications: boolean = false;

  selectedApplicationsCount: number = this.constants.FALSE;

  selectedApplicationsAmount: number = this.constants.FALSE;

  masterCurrencyCode: string = this.constants.BLANK;

  masterCurrencySymbol: string = this.constants.BLANK;

  private loggedUserId: string = this.constants.BLANK;

  hashData: string = this.constants.BLANK

  selectedCompletedApplication: any = {};

  incompleteTableHeadings: any = [{ 'label': 'Applicant Name', 'width': '25' }, { 'label': 'Date Of Birth', 'width': '20' }, { 'label': 'Application No.', 'width': '20' }, { 'label': 'Reference No.', 'width': '20' }, { 'label': 'Action', 'width': '15' }];

  private loaderTaskId: string = 'DASHBOARD_';

  applicantIds: any[]

  constructor(public constants: Constants, private httpUtils: HttpUtils, private toast: Toast, private localStorage: LocalStorage, private loaderService: LoaderService,
    private simpleModalService: SimpleModalService, private gui: GUI) {
    this.currentTab = this.constants.INCOMPLETE;
    this.loggedUserId = this.localStorage.getLoggedUserId();
    this.storeDashboardData();
  }

  ngOnInit(): void {
    this.dashboardForm = document.forms['dashboardForm'];
  }



  openGatewayModal() {
    const applicationsList = this.fetchSelectedApplications();

    const appIDS = this.applicantIds || [];

    console.log("applicationsList", applicationsList)
    if (applicationsList) {
      const newIds = [
        ...applicationsList.MiscData?.applications.map(d => d.applicantId)
      ].filter(id => !appIDS.includes(id));

      appIDS.push(...newIds);
    }

    this.applicantIds = appIDS;



    this.simpleModalService.addModal(SelectPaymentModalComponent, {
      applicationsList: this.applicantIds
    }).subscribe(result => {
      if (result) {
        console.log('Selected result:', result);
      }
    });
  }



  private storeDashboardData(): void {
    this.loaderService.startLoaderV2(this.loaderTaskId + '1');
    this.httpUtils.fetchDashboardData(this.loggedUserId).then(serverResponse => {
      this.loaderService.stopLoaderV2(this.loaderTaskId + '1');
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.incompleteApplicationsList = serverResponse.incompleteApplicationsList;

        this.completedApplicationsList = serverResponse.completedApplicationsList;

        this.paidApplicationsList = serverResponse.paidApplicationsList;

        this.masterCurrencyCode = serverResponse.currencyCode;

        this.masterCurrencySymbol = serverResponse.currencySymbol;
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  selectAllCompletedApplications() {
    let applicationsTotalCount: number = this.constants.FALSE;
    let applicationsTotalAmount: number = this.constants.FALSE;

    for (let i = 0; i < this.completedApplicationsList.length; i++) {
      const applicationFee = this.completedApplicationsList[i].applicationFee;
      const applicationExpiryStatus = this.completedApplicationsList[i].applicationExpiryStatus;

      if (applicationFee === this.constants.FALSE || applicationExpiryStatus === this.constants.TRUE) {
        continue;
      }

      this.completedApplicationsList[i].selected = this.selectedAllApplications;
      if (this.selectedAllApplications === true) {
        applicationsTotalAmount = applicationsTotalAmount + this.completedApplicationsList[i].applicationFee;
        applicationsTotalCount = applicationsTotalCount + 1;
      }
    }

    this.selectedApplicationsCount = applicationsTotalCount;
    this.selectedApplicationsAmount = applicationsTotalAmount;
  }




  // checkIfAllCompletedApplicationsSelected(completedApplication: any) {
  //   // Check if this selection would exceed max limit
  //   const selectedFamilyIds = this.selectAllWithSameParent(); // Get family group IDs
  //   const familyApplications = this.completedApplicationsList.filter(app =>
  //     selectedFamilyIds.includes(app.applicantId)
  //   );

  //   const totalAmountForFamily = familyApplications.reduce(
  //     (sum, app) => sum + app.applicationFee, 0
  //   );

  //   const currentlySelectedAmount = this.completedApplicationsList
  //     .filter(app => app.selected)
  //     .reduce((sum, app) => sum + app.applicationFee, 0);

  //   const projectedTotalAmount = currentlySelectedAmount + totalAmountForFamily;

  //   // If total would exceed max, prevent selection
  //   if (projectedTotalAmount > this.constants.MAX_AMOUNT) {
  //     completedApplication.selected = false;
  //     this.toast.showErrorToast(`You cannot pay more than ${this.constants.MAX_AMOUNT} at once.`);
  //     return;
  //   }

  //   // Select all related family applications
  //   this.completedApplicationsList.forEach(app => {
  //     if (selectedFamilyIds.includes(app.applicantId)) {
  //       app.selected = true;
  //     }
  //   });

  //   // Update if all are selected
  //   this.selectedAllApplications = this.completedApplicationsList.every((item: any) => item.selected === true);

  //   if (this.selectedAllApplications) {
  //     this.selectAllCompletedApplications();
  //     return;
  //   }

  //   // Recalculate count and amount
  //   let applicationsTotalCount = 0;
  //   let applicationsTotalAmount = 0;

  //   this.completedApplicationsList.forEach(app => {
  //     if (app.selected === true) {
  //       applicationsTotalCount++;
  //       applicationsTotalAmount += app.applicationFee;
  //     }
  //   });

  //   this.selectedApplicationsCount = applicationsTotalCount;
  //   this.selectedApplicationsAmount = applicationsTotalAmount;
  // }


  checkIfAllCompletedApplicationsSelected() {
    // First check if all applications are selected
    this.selectedAllApplications = this.completedApplicationsList.every((item: any) => {
      return item.selected == true;
    });

    // If one application is selected, find and select all family members
    const selectedApp = this.completedApplicationsList.find(app => app.selected === true);
    if (selectedApp) {
      const familyIds = this.selectAllWithSameParent();

      // Select all family members
      this.completedApplicationsList.forEach(app => {
        if (familyIds.includes(app.applicantId)) {
          app.selected = true;
        }
      });
    }

    if (this.selectedAllApplications) {
      this.selectAllCompletedApplications();
      return;
    }

    let applicationsTotalCount = this.constants.FALSE;
    let applicationsTotalAmount = this.constants.FALSE;

    for (let i = 0; i < this.completedApplicationsList.length; i++) {
      if (this.completedApplicationsList[i].selected === true) {
        applicationsTotalCount++;
        applicationsTotalAmount = applicationsTotalAmount + this.completedApplicationsList[i].applicationFee;
      }
    }

    this.selectedApplicationsCount = applicationsTotalCount;
    this.selectedApplicationsAmount = applicationsTotalAmount;
  }





  // Helper function to find all family members
  selectAllWithSameParent(): string[] {
    const selectedApp = this.completedApplicationsList.find(app => app.selected === true);

    if (!selectedApp) {
      return [];
    }

    // Find the root parent (could be the selected app itself or its parent)
    let rootParentId = selectedApp.parentId || selectedApp.applicantId;

    // Walk up the parent chain to find the ultimate parent
    let currentParentId = rootParentId;
    let foundParent;
    do {
      foundParent = this.completedApplicationsList.find(app =>
        app.applicantId === currentParentId
      );
      if (foundParent && foundParent.parentId) {
        currentParentId = foundParent.parentId;
      } else {
        break;
      }
    } while (true);

    rootParentId = currentParentId;

    // Find all family members
    const familyIds = new Set([rootParentId]);
    let changed;
    do {
      changed = false;
      this.completedApplicationsList.forEach(app => {
        if (
          (familyIds.has(app.applicantId) || familyIds.has(app.parentId)) &&
          !familyIds.has(app.applicantId)
        ) {
          familyIds.add(app.applicantId);
          changed = true;
        }
      });
    } while (changed);

    return Array.from(familyIds);
  }

  openApplicationForm() {
    this.gui.openApplicationAddEditPage(this.constants.BLANK);
  }

  viewApplication(applicantId: string) {
    this.gui.openApplicationViewPage(applicantId);
  }

  openSearchModel() {
    this.simpleModalService.addModal(SearchModalComponent, { isUnpaidSearch: this.constants.TRUE }, { autoFocus: true }).subscribe((isApplicationAdded: boolean) => {
      if (isApplicationAdded === true) {
        this.storeDashboardData();
      }
    });
  }

  editApplication(applicantId: string) {
    this.gui.openApplicationAddEditPage(applicantId);
  }

  showDeleteConfirmation(applicantId: string, applicationId: string, isDeleteIncomplete: number) {
    const appendMessgae = isDeleteIncomplete === this.constants.TRUE ? 'this application?' : 'the application number ' + applicationId + '?'
    const message = 'Are you sure you want to delete ' + appendMessgae;
    const modalParamsObject = { title: 'Confirmation', message: message, confirmButtonLabel: 'YES', cancelButtonLabel: 'NO', isShowCancelButton: true };
    this.simpleModalService.addModal(ConfirmationModalComponent, modalParamsObject, { autoFocus: true }).subscribe((isConfirmed: boolean) => {
      if (isConfirmed === true) {
        this.deleteApplication(applicantId, isDeleteIncomplete);
      }
    });
  }

  private deleteApplication(applicantId: string, isDeleteIncomplete: number) {
    this.loaderService.startLoaderV2(this.loaderTaskId + '2');
    this.httpUtils.deleteApplication(this.loggedUserId, applicantId, isDeleteIncomplete).then(serverResponse => {
      this.loaderService.stopLoaderV2(this.loaderTaskId + '2');
      this.selectedAllApplications = false;
      this.selectedApplicationsCount = this.constants.FALSE;
      this.selectedApplicationsAmount = this.constants.FALSE;
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.toast.showSuccessToast('Your application has been deleted successfully');
        this.storeDashboardData();
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  // private fetchSelectedApplications() {
  //   const applicantIds = [];
  //   for (let i = 0; i < this.completedApplicationsList.length; i++) {
  //     if (this.completedApplicationsList[i].selected === true) {
  //       this.selectedCompletedApplication = this.completedApplicationsList[i];
  //       applicantIds.push(this.completedApplicationsList[i].applicantId);
  //     }
  //   }
  //   return applicantIds;
  // }



  private fetchSelectedApplications() {
    const applications = [];

    for (let i = 0; i < this.completedApplicationsList.length; i++) {
      const app = this.completedApplicationsList[i];

      if (app.selected === true) {
        this.selectedCompletedApplication = app;

        applications.push({
          appId: app.applicationId,
          refNumber: app.referenceId,
          applicantId: app.applicantId
        });
      }
    }
    return {
      MiscData: {
        applications
      }
    };
  }

  initiatePayment() {
    // this.loaderService.startLoaderV2(this.loaderTaskId + '3');
    const applicationsList = this.fetchSelectedApplications();
    // this.startPayment()
    this.openGatewayModal()
    // this.httpUtils.initiatePayment(this.loggedUserId, applicationsList).then(serverResponse => {
    //   if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
    //     this.openIOSPaymentPage(serverResponse.redirectUrl);
    //   } else {
    //     this.loaderService.stopLoaderV2(this.loaderTaskId + '3');
    //     this.toast.showErrorToast(serverResponse.responseMsg);
    //     this.selectedAllApplications = false;
    //     this.selectedApplicationsCount = this.constants.FALSE;
    //     this.selectedApplicationsAmount = this.constants.FALSE;
    //     this.storeDashboardData();
    //   }
    // });
  }



  // private startPayment(): void {
  //   const hashPayload = {
  //     amount: this.selectedCompletedApplication?.applicationFee.toFixed(2),
  //     transactionId: this.selectedCompletedApplication?.applicationId
  //   }

  //   try {
  //     this.httpUtils
  //       .getHash(hashPayload)
  //       .then((serverResponse) => {
  //         console.log("payment serveer response", serverResponse?.data)
  //         this.hashData = serverResponse?.data;

  //       })
  //       .catch((error) => {
  //         console.error('Error while starting payment:', error);
  //       });
  //   } catch (error) {
  //     console.error('Unexpected error:', error);
  //   }

  //   const data = `${environment.raveMerchant}${this.selectedCompletedApplication?.applicationFee.toFixed(2)}${this.selectedCompletedApplication?.applicationId.toString()}`;
  //   // const hash = CryptoJS.HmacSHA1(data, environment.raveKey).toString();
  //   const payload = {
  //     serviceId: environment.raveService,
  //     txnRefNumber: this.selectedCompletedApplication?.applicationId,
  //     amount: this.selectedCompletedApplication?.applicationFee.toFixed(2),
  //     countryId: "US",
  //     hash: this.hashData,
  //     extraInformation: `${this.selectedCompletedApplication?.referenceId} | ${this.selectedCompletedApplication?.applicationId} | ${this.selectedCompletedApplication?.fullName}`,
  //     successUrl: `${environment.keycloakRedirectUrl}rave-payment/${this.selectedCompletedApplication?.applicationId}/${this.selectedCompletedApplication?.referenceId}`,
  //     cancelUrl: `${environment.keycloakRedirectUrl}rave-payment-fail/${this.selectedCompletedApplication?.applicationId}/${this.selectedCompletedApplication?.referenceId}`,
  //   };
  //   try {
  //     this.httpUtils
  //       .startRavePayment(payload)
  //       .then((serverResponse) => {
  //         console.log("payment serveer response", serverResponse)
  //         if (serverResponse?.data?.redirect_url) {
  //           window.location.href = serverResponse?.data?.redirect_url;
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error while starting payment:', error);
  //       });
  //   } catch (error) {
  //     console.error('Unexpected error:', error);
  //   }
  // }

  private startPayment(): void {
    const application = this.selectedCompletedApplication;
    if (!application) {
      console.error('No application selected.');
      this.toast.showErrorToast('No application selected.');
      return;
    }

    const amount = this.selectedApplicationsAmount.toFixed(2);
    const transactionId = application.applicationId?.toString();
    const referenceId = application.referenceId;
    const fullName = application.fullName;
    const applicationsList = this.fetchSelectedApplications();



    const payload = {
      loggedUserId: this.loggedUserId,
      txnRefNumber: transactionId,
      amount,
      countryId: "US",
      successUrl: `${environment.keycloakRedirectUrl}dashboard`,
      cancelUrl: `${environment.keycloakRedirectUrl}dashboard`,
      miscData: applicationsList.MiscData
    };

    // Step 1: Start payment directly
    this.httpUtils.startRavePayment(payload)
      .then((paymentResponse) => {
        const redirectUrl = paymentResponse?.data?.redirect_url;
        if (redirectUrl) {
          this.toast.showSuccessToast('Redirecting to payment gateway...');
          window.location.href = redirectUrl;
        } else {
          this.toast.showErrorToast(paymentResponse?.responseMsg);
          this.loaderService.stopAllLoader();

        }
      })
      .catch((error) => {
        console.error('Payment process failed:', error);
        this.toast.showErrorToast(error?.message || 'An error occurred while processing the payment.');
      });
  }




  private openIOSPaymentPage(redirectUrl: string) {
    if (environment.isEnableIOSV2 === true) {
      window.location.href = redirectUrl;
    } else {
      this.loaderService.startLoader();
      this.dashboardForm.action = environment.serverBaseUrl + 'payment/openIOSPaymentPage';
      this.dashboardForm.loggedUserId.value = this.loggedUserId;
      this.dashboardForm.submit();
    }
  }

  checkPaymentStatus(applicantId: string): void {
    this.loaderService.startLoaderV2(this.loaderTaskId + '4');
    const loggedUserId = this.localStorage.getLoggedUserId();
    this.httpUtils.checkPaymentStatusOnIOS(loggedUserId, applicantId, false).then(serverResponse => {
      this.loaderService.stopLoaderV2(this.loaderTaskId + '4');
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        const checkPaymentResponseCode = serverResponse.checkPaymentResponseCode;
        const checkPaymentResponseMsg = serverResponse.checkPaymentResponseMsg;
        if (checkPaymentResponseCode === this.constants.STATUS_SUCCESS) {
          this.toast.showSuccessToast(checkPaymentResponseMsg);
          this.storeDashboardData();
        } else {
          this.toast.showErrorToast(checkPaymentResponseMsg);
        }
      } else if (serverResponse.responseCode === this.constants.PAYMENT_ALREADY_COMPLETE) {
        this.storeDashboardData();
        this.toast.showErrorToast(serverResponse.responseMsg);
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }




}
